import { createReducer, on } from '@ngrx/store';
import {
  STATUS_FIND_SUCCESS,
  STATUS_FAILURE,
} from '../actions';
import {
  Status,
} from '@core/models';

export interface StatusState {
  loading: boolean;
  statusList: Status[] | null;
  error: string | null;
}

export const initialState: StatusState = {
  loading: false,
  statusList: null,
  error: null,
};

export const statusReducer = createReducer(
  initialState,
  on(STATUS_FAILURE, (status, { error }) => ({ ...status, error })),
  on(STATUS_FIND_SUCCESS, (status, { statusList }) => ({ ...status,  statusList:  statusList })),
);
